module.exports = __webpack_public_path__ + "img/logo.726d2c5c.jpg";